import types from './types';

const addNewFilter = (newFilter) => ({
  type: types.ADD_NEW_FILTER,
  payload: {
    newFilter
  }
});

const saveFilterEdit = (filter) => ({
  type: types.SAVE_FILTER_EDIT,
  payload: {
    filter
  }
});

const setActiveFilter = (filter) => ({
  type: types.SET_ACTIVE_FILTER,
  payload: {
    filter
  }
});

const removeFilter = (filterToRemove) => ({
  type: types.REMOVE_FILTER,
  payload: {
    filterToRemove
  }
});

const nukeFilters = () => ({
  type: types.NUKE_FILTERS,
  payload: {
  }
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  addNewFilter,
  saveFilterEdit,
  removeFilter,
  nukeFilters,
  setActiveFilter
};
